import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  saleReturnProducts,
  addQuantityReducer,
  removeQuantityReducer,
  removeItemFormCartReducer,
  customQtyReducer,
  removeItemFormReturnCartReducer,
  customPriceReducer,
} from "../../../../features/posSlice";
import PriceSelectByProduct from "../../../Common/CustomSelect/PriceSelectByProduct";
import { signInUser } from "../../../Utility/Auth";
import { useSettingsQuery } from "../../../../services/settingsApi";
import {
  itemVat,
  // posFinalizer,
  itemVatTotal,
  toDecimal,
} from "../../../Utility/PosCalculations";

const PosCart = ({
  // addQuantities,
  // removeQuantities,
  removeFromCart,
  handleCustomQty,
  updateCart,
  invoice,
  returnProducts,
  reCal,
  settings,
}) => {
  let i = 1;
  let j = 1;
  // console.log(carts)
  const dispatch = useDispatch();
  const [tempQty, setTempQty] = useState([]);
  const [reTempQty, setReTempQty] = useState([]);
  // const [scValue, setScValue] = useState("");
  const posSaleData = useSelector((state) => state.posReducer);
  const carts = useSelector((state) => state.posReducer.products);
  const reCarts = useSelector((state) => state.posReducer.returnProducts);
  const auth = signInUser();
  const { data: dbSettings } = useSettingsQuery(auth?.aamarId, {
    skip: !auth?.aamarId,
  });
  const currentSettings = settings || dbSettings || auth?.storeSettings;
  const isPriceEditable = Boolean(currentSettings?.isPriceEditable);

  // console.log("POS-DATA::", posSaleData)

  const handleOnChangePrice = (id, e, article_code) => {
    dispatch(customPriceReducer({ id: id, article_code: article_code, e: e }));
  };

  const returnCustomQuantity = (qty, article_code) => {
    //console.log(qty)
    if (reCarts) {
      // Find the selected item and the rest of the items
      const selectedItem = reCarts.find((p) => p.article_code === article_code);
      const restItems = reCarts.filter((p) => p.article_code !== article_code);

      if (!selectedItem) {
        console.error(
          "Item not found in cart with article_code:",
          article_code
        );
        return;
      }

      // Ensure `qty` is parsed as an integer
      const parsedQty = parseFloat(qty);

      // Update quantity based on conditions
      let newQty = selectedItem.qty; // Default to current quantity

      if (parsedQty >= 0 && parsedQty <= selectedItem.max_qty) {
        newQty = parsedQty; // Within range
      } else if (parsedQty > selectedItem.max_qty) {
        newQty = selectedItem.max_qty; // Cap to max quantity
      } else {
        newQty = 0; // Default to 0 if invalid
      }

      // Update selectedItem with the new quantity
      const updatedSelectedItem = {
        ...selectedItem,
        qty: newQty,
      };

      // Combine updated items and sort
      const updatedCart = [...restItems, updatedSelectedItem].sort(
        (a, b) => a.order - b.order
      );

      // Dispatch the updated cart
      dispatch(saleReturnProducts(updatedCart));
    }
  };

  return (
    <>
      {carts && carts.length > 0 ? (
        carts
          .slice()
          .sort((a, b) => a.order - b.order)
          .map((cartItem, index) => (
            <tr key={cartItem.article_code}>
              <th scope="row">{index + 1}</th>
              <td
                style={{
                  width: window.innerWidth <= 576 ? "220px" : "300px",
                }}
                title={cartItem.article_code}
              >
                {cartItem.name}
              </td>

              <td>
                {isNaN(Number(cartItem?.stock))
                  ? `0.00 ${cartItem?.unit || ""}`
                  : `${Number(cartItem?.stock).toFixed(2)} ${cartItem?.unit || ""}`}
              </td>
              <td
                className="text-center align-middle"
                style={{
                  width: window.innerWidth <= 576 ? "150px" : "180px",
                }}
              >
                {isPriceEditable ? (
                  <PriceSelectByProduct
                    sc={cartItem.id}
                    setVal={cartItem.mrp}
                    initialMrp={cartItem.originalMrp || cartItem.mrp}
                    tp={cartItem.tp}
                    article_code={cartItem.article_code}
                    handleOnChangeCategory={handleOnChangePrice}
                    editable={true}
                  />
                ) : (
                  <span
                    className="fw-bold"
                    style={{ fontSize: "14px", color: "#212529" }}
                  >
                    {cartItem.mrp}
                  </span>
                )}
              </td>

              <td className="col-md-2">
                <div className="input-group" style={{ width: "180px" }}>
                  {/* Decrement Button */}
                  <div className="input-group-prepend">
                    <div
                      onClick={() =>
                        dispatch(removeQuantityReducer(cartItem.article_code))
                      }
                      className="input-group-text"
                    >
                      <Icons.Minus size="28" />
                    </div>
                  </div>

                  {/* Quantity Input */}
                  <input
                    type="number"
                    className="form-control quantity"
                    id={cartItem.article_code}
                    value={cartItem.qty}
                    onChange={(e) =>
                      dispatch(
                        customQtyReducer({
                          qty: e.target.value,
                          article_code: cartItem.article_code,
                        })
                      )
                    }
                  />

                  {/* Increment Button */}
                  <div className="input-group-append">
                    <div
                      onClick={() =>
                        dispatch(addQuantityReducer(cartItem.article_code))
                      }
                      className="input-group-text"
                    >
                      <Icons.Plus size="28" />
                    </div>
                  </div>
                </div>
              </td>

              {/* <td>
                {toDecimal(
                  parseFloat(itemVat(cartItem.vat, cartItem.qty, cartItem.mrp))
                )}
              </td> */}
              <td className="text-end">
                {toDecimal(cartItem?.total)}
               
              </td>
              <td className="text-end"> <Icons.X
                  className="float-end"
                  onClick={() =>
                    dispatch(removeItemFormCartReducer(cartItem.article_code))
                  }
                /></td>
            </tr>
          ))
      ) : (
        <tr>
          <th scope="row" colSpan="7">
            <p className="text-center">No Item in Cart</p>
          </th>
        </tr>
      )}

      {posSaleData.returnProducts?.length > 0 && (
        <>
          <tr>
            <th className="border-bottom-1 border-top-1" colSpan="">
              <b>#</b>
            </th>
            <th className="border-bottom-1 border-top-1" colSpan="6">
              <b>Return Products</b>
            </th>
          </tr>
          {reCarts
            ?.slice()
            ?.sort((a, b) => a.order - b.order)
            ?.map((reItem, index) => (
              <tr key={reItem.article_code}>
                <th scope="row">{index + 1}</th>
                <td title={reItem.article_code}>{reItem.name}</td>
                <td> - </td>
                <td>{reItem.mrp}</td>
                <td className="col-md-2">
                  <input
                    type="number"
                    className="form-control quantity"
                    id={reItem.article_code}
                    onChange={(e) =>
                      returnCustomQuantity(e.target.value, reItem.article_code)
                    }
                    value={reItem.qty}
                  />
                </td>
                <td>
                  {/* {parseFloat(
                    itemVat(reItem.vat, reItem.qty, reItem.mrp)
                  ).toFixed(2)} */}
                </td>
                <td>
                  {toDecimal(reItem?.qty* reItem?.mrp)}

                  <Icons.X
                    className="float-end"
                    onClick={() =>
                      dispatch(
                        removeItemFormReturnCartReducer(reItem.article_code)
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          <tr>
            <th></th>
            <th className="border-bottom-1 border-top-1">
              <b>Item No:</b> {posSaleData?.returnCal?.totalItem}
            </th>
            <td>
              <b>Total:</b> {posSaleData?.returnCal?.total?.toFixed(2)}
            </td>
            <td>
              {/* <b>Vat:</b> {posSaleData?.returnCal?.vat?.toFixed(2)} */}
            </td>
            <td>
              <b>Gross Total:</b>{" "}
              {parseFloat(posSaleData?.returnCal?.grossTotal)?.toFixed(2)}
            </td>
            <td>
              <b>Round Total:</b>{" "}
              {posSaleData?.returnCal?.grossTotalRound?.toFixed(2)}
            </td>
            <td>
              <b>Point:</b> {posSaleData?.returnCal?.point}
            </td>
          </tr>
        </>
      )}
    </>
  );
};

export default PosCart;
